'use client';

import * as React from 'react';
import Box from '@mui/material/Box';
import { useColorScheme } from '@mui/material/styles';
import LogoLight from '@/assets/logos/logo-new.png';
import LogoDark from '@/assets/logos/logo-new.png';
import EmblemLight from '@/assets/logos/logo-new.png';
import EmblemDark from '@/assets/logos/logo-new.png';
import { NoSsr } from '@/components/core/v2/no-ssr';

const HEIGHT = 60;
const WIDTH = 60;

type Color = 'dark' | 'light';

export interface LogoProps {
  color?: Color;
  emblem?: boolean;
  height?: number;
  width?: number | 'auto';
}

export function Logo({ color = 'dark', emblem, height = HEIGHT, width = 'auto' }: LogoProps): React.JSX.Element {
  let src: string;

  if (emblem) {
    src = color === 'light' ? EmblemDark : EmblemLight;
  } else {  
    src = color === 'light' ? LogoDark : LogoLight;
  }

  return <Box alt="logo" component="img" height={height} src={src} width={width} />;
}

export interface DynamicLogoProps {
  colorDark?: Color;
  colorLight?: Color;
  emblem?: boolean;
  height?: number;
  width?: number;
}

export function DynamicLogo({
  colorDark = 'light',
  colorLight = 'dark',
  height = HEIGHT,
  width = WIDTH,
  ...props
}: DynamicLogoProps): React.JSX.Element {
  const { colorScheme } = useColorScheme();
  const color = colorScheme === 'dark' ? colorDark : colorLight;

  return (
    <NoSsr fallback={<Box sx={{ height: `${height}px`, width: `${width}px` }} />}>
      <Logo color={color} height={height} width={width} {...props} />
    </NoSsr>
  );
}
